import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import Axios from 'axios'
import VueHead from 'vue-head'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueHead, {
    separator: '|',
    complement: 'RKW Digitalisierungscockpit'
})
Vue.use(Vue2TouchEvents)

import NavModel from './vuejs/components/NavModel.vue'
Vue.component('nav-model', NavModel)

import NavMechanism from './vuejs/components/NavMechanism.vue'
Vue.component('nav-mechanism', NavMechanism)

import NavTask from './vuejs/components/NavTask.vue'
Vue.component('nav-task', NavTask)

import ContentModal from './vuejs/components/ContentModal.vue'
Vue.component('content-modal', ContentModal)

import ContentDetail from './vuejs/components/ContentDetail.vue'
Vue.component('content-detail', ContentDetail)

import BookmarkModal from './vuejs/components/BookmarkModal.vue'
Vue.component('bookmark-modal', BookmarkModal)

import MechanismImage from './vuejs/components/MechanismImage.vue'
Vue.component('mechanism-image', MechanismImage)

import ApplicationTour from './vuejs/components/ApplicationTour'
Vue.component('application-tour',ApplicationTour)

import SelectBox from './vuejs/components/SelectBox.vue'
Vue.component('select-box',SelectBox)

import ContentSlider from './vuejs/components/ContentSlider.vue'
Vue.component('content-slider',ContentSlider)

import Storage from './vuejs/storage'
import mixins from './vuejs/mixins'
//import routing from './vuejs/routing'

let routing = {
    mode: 'history',
    //base: '/',
    routes: [
        // dynamische Segmente beginnen mit Doppelpunkt
        { path: '/', name: 'home' },
        { path: '/beispiel/:instance', component: ContentModal, name: "instance"},
        { path: '/bookmarks', name: 'bookmarks', children: [
                {
                    path: 'entries/:entries',
                    name: 'bookmarkEntries'
                }
            ]
        }
    ]
}

const _VIEWPORT = {
    mobile: "width=375, user-scalable=no",
    desktop: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
}

Axios.get(host.uri + host.api)
    .then(function (response) {
        Storage.state.data = response['data']
        global.store = new Vuex.Store(Storage)
        global.router = new VueRouter(routing)

        new Vue({
            el: '#rkwDigiKit',
            store,
            router,
            mixins: [mixins],
            created: function () {
                window.setTimeout(() => {
                    document.getElementById('rkwDigiKit').className += ' start'
                }, 200)
                window.addEventListener('orientationchange', (e) => {
                    let viewport = document.querySelector("meta[name=viewport]")
                    viewport.setAttribute('content', _VIEWPORT.desktop);
                    window.setTimeout(() => {
                        if(this.isMobile()) {
                            viewport.setAttribute('content', _VIEWPORT.mobile);
                        } else {
                            viewport.setAttribute('content', _VIEWPORT.desktop);
                        }
                    }, 250)
                })
            },
            beforeMount: function() {
                let viewport = document.querySelector("meta[name=viewport]")
                if(this.isMobile()) {
                    viewport.setAttribute('content', _VIEWPORT.mobile);
                } else {
                    viewport.setAttribute('content', _VIEWPORT.desktop);
                }
            },
            computed: {
                viewport () {
                    // return (this.isMobile()) ? 'width=375, user-scalable=no' : 'width=device-width, initial-scale=1, user-scalable=no'
                },
                settings () {
                    return store.state.settings
                },
                digiKit () {
                    return store.state.data
                },
                activeItems () {
                    return store.state.runtime.activeItems
                },
                footer () {
                    return this.$store.state.data.footer
                },
                bookmarks () {
                    return store.state.runtime.bookmarks
                },
                isNavOpen () {
                    return this.$store.state.runtime.openNavigation
                }
            },
            methods: {
                toggleBookmarkModal: function () {
                    this.$store.commit('toggleBookmarkModal')
                },
                goToStart: function() {
                    this.$store.commit('unsetActiveItems')
                }
            },
            watch: {
                '$route' (to, from) {
                    if(this.$route.name !== "bookmarks") {
                        this.$store.commit('closeBookmarkModal')
                    }
                    if(this.$route.name !== "instance" && this.$route.name !== "bookmarks") {
                        this.$store.commit('unsetActiveItems')
                    }
                },
                '$store.state.runtime.activeItems.model' () {
                    this.$store.commit('updateNavigationState')
                }
            }
        })
    })
    .catch(function (error) {
        console.log(error);
    });



// WEBPACK FOOTER //
// ./source/app.js